import { ILoginSuccess } from "../../interfaces/auth";
import { ISignUpDto } from "../../interfaces/dto/auth.dto";

enum AuthActions {
  AUTH_LOGIN = "AUTH_LOGIN",
  AUTH_LOGOUT = "AUTH_LOGOUT",
  AUTH_SET_EMAIL = "AUTH_SET_EMAIL",
  AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS",
  AUTH_LOGIN_FAILURE = "AUTH_LOGIN_FAILURE",
  AUTH_SIGNOUT = "AUTH_SIGNOUT",
  AUTH_SIGNUP = "AUTH_SIGNUP",
  AUTH_SIGNUP_RESET = "AUTH_SIGNUP_RESET",
  AUTH_SIGNUP_SUCCESS = "AUTH_SIGNUP_SUCCESS",
  AUTH_SIGNUP_FAILURE = "AUTH_SIGNUP_FAILURE",
  AUTH_FORGOT_PASSWORD = "AUTH_FORGOT_PASSWORD",
  AUTH_FORGOT_PASSWORD_UPDATE = "AUTH_FORGOT_PASSWORD_UPDATE",
  AUTH_FORGOT_PASSWORD_SUCCESS = "AUTH_FORGOT_PASSWORD_SUCCESS",
  AUTH_FORGOT_PASSWORD_FAILURE = "AUTH_FORGOT_PASSWORD_FAILURE",
}

interface IResetSingupAction {
  type: AuthActions.AUTH_SIGNUP_RESET;
}

export const resetSignupAction = (): IResetSingupAction => ({
  type: AuthActions.AUTH_SIGNUP_RESET,
});

interface IForgotPasswordUpdateAction {
  type: AuthActions.AUTH_FORGOT_PASSWORD_UPDATE;
}

export const forgotPasswordUpdateAction = (): IForgotPasswordUpdateAction => ({
  type: AuthActions.AUTH_FORGOT_PASSWORD_UPDATE,
});

interface IForgotPasswordAction {
  type: AuthActions.AUTH_FORGOT_PASSWORD;
}

export const forgotPasswordAction = (): IForgotPasswordAction => ({
  type: AuthActions.AUTH_FORGOT_PASSWORD,
});

interface IForgotPasswordSuccessAction {
  type: AuthActions.AUTH_FORGOT_PASSWORD_SUCCESS;
  payload: ISignUpDto;
}

export const forgotPasswordSuccessAction = (
  payload: ISignUpDto,
): IForgotPasswordSuccessAction => ({
  type: AuthActions.AUTH_FORGOT_PASSWORD_SUCCESS,
  payload,
});

interface ISignupAction {
  type: AuthActions.AUTH_SIGNUP;
}

export const signupAction = (): ISignupAction => ({
  type: AuthActions.AUTH_SIGNUP,
});

interface ISignupSuccessAction {
  type: AuthActions.AUTH_SIGNUP_SUCCESS;
  payload: ISignUpDto;
}

export const signupSuccessAction = (
  payload: ISignUpDto,
): ISignupSuccessAction => ({ type: AuthActions.AUTH_SIGNUP_SUCCESS, payload });

interface IForgotPasswordFailureAction {
  type: AuthActions.AUTH_FORGOT_PASSWORD_FAILURE;
  payload: {
    error: string;
  };
}

export const forgotPasswordFailureAction = (
  error: string,
): IForgotPasswordFailureAction => ({
  type: AuthActions.AUTH_FORGOT_PASSWORD_FAILURE,
  payload: { error },
});

interface ISingupFailureAction {
  type: AuthActions.AUTH_SIGNUP_FAILURE;
  payload: {
    error: string;
  };
}

export const signupFailureAction = (error: string): ISingupFailureAction => ({
  type: AuthActions.AUTH_SIGNUP_FAILURE,
  payload: { error },
});

interface ISetEmailAction {
  type: AuthActions.AUTH_SET_EMAIL;
  payload: {
    email: string;
  };
}

export const setEmailAction = (email: string): ISetEmailAction => ({
  type: AuthActions.AUTH_SET_EMAIL,
  payload: {
    email,
  },
});

interface IAuthAction {
  type: AuthActions.AUTH_LOGIN;
}

export const loginAction = (): IAuthAction => ({
  type: AuthActions.AUTH_LOGIN,
});

interface ILogoutAction {
  type: AuthActions.AUTH_LOGOUT;
}

export const logoutAction = (): ILogoutAction => ({
  type: AuthActions.AUTH_LOGOUT,
});

interface IAuthLoginSuccessAction {
  type: AuthActions.AUTH_LOGIN_SUCCESS;
  payload: ILoginSuccess;
}

export const loginSuccessAction = (
  payload: ILoginSuccess,
): IAuthLoginSuccessAction => ({
  type: AuthActions.AUTH_LOGIN_SUCCESS,
  payload,
});

interface IAuthLoginFailureAction {
  type: AuthActions.AUTH_LOGIN_FAILURE;
  payload: {
    error: string;
  };
}
export const loginFailureAction = (error: string): IAuthLoginFailureAction => ({
  type: AuthActions.AUTH_LOGIN_FAILURE,
  payload: { error },
});

export type IAuthActions =
  | IAuthLoginFailureAction
  | IAuthLoginSuccessAction
  | IAuthAction
  | ILogoutAction
  | ISetEmailAction
  | ISignupAction
  | ISignupSuccessAction
  | ISingupFailureAction
  | IForgotPasswordAction
  | IForgotPasswordUpdateAction
  | IForgotPasswordSuccessAction
  | IForgotPasswordFailureAction
  | IResetSingupAction;
